/**
 * Mechanism chip metadata — one place for label, tone and the plain-words
 * explanation shown in the EdgeDrawer (spec §7 J3).
 */
const MECHANISM_META = {
  level: {
    label: 'Drives level',
    tone: 'primary',
    description: 'Moves the target up or down in a consistent direction.',
  },
  volatility: {
    label: 'Drives volatility',
    tone: 'warning',
    description: 'Does not move the target itself — it widens or narrows how much the target swings.',
  },
  trend_shift: {
    label: 'Shifts the trend',
    tone: 'error',
    description: 'Events of this type durably change the target\u2019s level or trend, not just perturb it briefly.',
  },
  nonlinear: {
    label: 'Non-linear effect',
    tone: 'secondary',
    description: 'The effect changes shape across the driver\u2019s range (thresholds, saturation, U-shapes).',
  },
  mean: {
    label: 'Drives level',
    tone: 'primary',
    description: 'Moves the target up or down in a consistent direction.',
  },
  variance: {
    label: 'Drives volatility',
    tone: 'warning',
    description: 'Widens or narrows how much the target swings.',
  },
};

export const mechanismMeta = (mechanism) =>
  MECHANISM_META[mechanism] || {
    label: mechanism || 'Unknown',
    tone: 'default',
    description: '',
  };

export const LIFECYCLE_META = {
  validated: { label: 'Validated', tone: 'success' },
  revalidated: { label: 'Validated', tone: 'success' },
  candidate: { label: 'Candidate', tone: 'default' },
  exploratory: { label: 'Suggestive', tone: 'secondary' },
  weakening: { label: 'Weakening', tone: 'warning' },
  broken: { label: 'Broken', tone: 'error' },
  archived: { label: 'Archived', tone: 'default' },
};

export const lifecycleMeta = (lifecycle) =>
  LIFECYCLE_META[lifecycle] || { label: lifecycle || 'Unknown', tone: 'default' };

export default mechanismMeta;
